import React, { Fragment } from "react";
import { branch, compose, renderComponent, withHandlers } from "recompose";
import {
  MenuItem,
  CollapsibleList,
  Classes,
  CollapseFrom,
  AnchorButton
} from "@blueprintjs/core";
import { MenuLink } from "app/MainMenu";
import { sizes } from "app/media";
import { injectIntl } from "react-intl";
import { getURLSearch } from "app/utils";

const getLocation = topicId => ({
  proposals: `/topics/${topicId}/proposals`,
  addProposal: `/topics/${topicId}/proposals/add`,
  myProposals: `/topics/${topicId}/proposals/my`,
  topicDetail: `/topics/${topicId}/details`,
  legend: `/topics/${topicId}/legend`
});

const MenuLinks = props => {
  const { screen, intl, topicTitle } = props;
  const location = getLocation(props.topicId);
  const urlSearch = getURLSearch();
  let visibleItemCount = 0;
  if (screen <= sizes.medium) {
    visibleItemCount = 0;
  } else if (screen <= sizes.large) {
    visibleItemCount = 0;
  } else {
    visibleItemCount = 2;
  }
  if (topicTitle && !topicTitle.includes("Design Museum")) {
    return (
      <CollapsibleList
        dropdownTarget={
          <AnchorButton
            className={`${Classes.MINIMAL} ${Classes.SMALL}`}
            iconName="menu"
          />
        }
        collapseFrom={CollapseFrom.END}
        visibleItemCount={visibleItemCount}
        visibleItemClassName={Classes.BREADCRUMB}
        renderVisibleItem={props => {
          const { href, text } = props;

          if (href)
            return (
              <MenuLink
                style={{ marginRight: "5px", marginLeft: "5px" }}
                to={href}
                activeOnlyWhenExact
              >
                {text}
              </MenuLink>
            );
        }}
      >
        <MenuItem
          text={intl.formatMessage({
            id: "topic.menu.details",
            defaultMessage: "Show topic details"
          })}
          href={location.topicDetail + urlSearch}
        />
        <MenuItem
          text={intl.formatMessage({
            id: "topic.menu.allproposals",
            defaultMessage: "Show all proposals"
          })}
          href={location.proposals + urlSearch}
        />
        <MenuItem
          text={intl.formatMessage({
            id: "topic.menu.addproposal",
            defaultMessage: "Add proposal"
          })}
          href={location.addProposal + urlSearch}
        />
        <MenuItem
          text={intl.formatMessage({
            id: "topic.menu.myproposals",
            defaultMessage: "My proposals"
          })}
          href={location.myProposals + urlSearch}
        />
        <MenuItem
          text={intl.formatMessage({
            id: "topic.menu.legend",
            defaultMessage: "Legend"
          })}
          href={location.legend + urlSearch}
        />
        {/*      <MenuLink to={location.topicDetail} activeOnlyWhenExact>
        Show topic details
      </MenuLink>
      <MenuLink to={location.proposals} activeOnlyWhenExact>
        Show all proposals
      </MenuLink>
      <MenuLink to={location.addProposal} activeOnlyWhenExact>
        Add proposal
      </MenuLink>
      <MenuLink to={location.myProposals} activeOnlyWhenExact>
        My proposals
      </MenuLink>*/}
      </CollapsibleList>
    );
  } else
    return (
      <CollapsibleList
        dropdownTarget={
          <AnchorButton
            className={`${Classes.MINIMAL} ${Classes.SMALL}`}
            iconName="menu"
          />
        }
        collapseFrom={CollapseFrom.END}
        visibleItemCount={visibleItemCount}
        visibleItemClassName={Classes.BREADCRUMB}
        renderVisibleItem={props => {
          const { href, text } = props;

          if (href)
            return (
              <MenuLink
                style={{ marginRight: "5px", marginLeft: "5px" }}
                to={href}
                activeOnlyWhenExact
              >
                {text}
              </MenuLink>
            );
        }}
      >
        <MenuItem
          text={intl.formatMessage({
            id: "topic.menu.details",
            defaultMessage: "Show topic details"
          })}
          href={location.topicDetail + urlSearch}
        />
      </CollapsibleList>
    );
};

const navigate = props => location => () => {
  props.history.push(location);
};

const MenuItems = withHandlers({ navigate })(props => {
  const { intl } = props;
  const location = getLocation(props.topicId);
  const urlSearch = window.location.search;
  const navigate = props.navigate;
  return (
    <Fragment>
      <MenuItem
        text={intl.formatMessage({
          id: "topic.menu.details",
          defaultMessage: "Show topic details"
        })}
        onClick={navigate(location.topicDetail + urlSearch)}
      />
      <MenuItem
        text={intl.formatMessage({
          id: "topic.menu.allproposals",
          defaultMessage: "Show all proposals"
        })}
        onClick={navigate(location.proposals + urlSearch)}
      />
      <MenuItem
        text={intl.formatMessage({
          id: "topic.menu.addproposal",
          defaultMessage: "Add proposal"
        })}
        onClick={navigate(location.addProposal + urlSearch)}
      />
      <MenuItem
        text={intl.formatMessage({
          id: "topic.menu.myproposals",
          defaultMessage: "My proposals"
        })}
        onClick={navigate(location.myProposals + urlSearch)}
      />
    </Fragment>
  );
});

export default compose(
  injectIntl,
  branch(props => Boolean(props.asMenu), renderComponent(MenuItems))
)(MenuLinks);



// WEBPACK FOOTER //
// ./src/app/topics/TopicMenu.js